import { CalendarDaysIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';

/**
 * Estado inicial da consolidação: nem plano nem ano definidos ainda.
 *
 * Substitui régua e tabela — e não fica ao lado delas — porque uma régua zerada
 * seria lida como "este plano não deve nada neste ano", que é uma afirmação
 * diferente de "ainda não escolhi o recorte".
 *
 * A explicação de dois níveis (título + descrição) vem do frame `sg9xy` de
 * `design/payment.pen`: o operador que chega pela primeira vez precisa saber o
 * que "consolidar" significa antes de escolher o ano.
 */
export function ConsolidationEmptyState() {
  const { t } = useTranslation('individualPayment');

  return (
    <div className="flex flex-col items-center gap-micro rounded-sm border-hairline border-ctx-layout-border bg-ctx-layout-surface px-xs py-xl">
      <span className="flex items-center justify-center rounded-pill bg-ctx-layout-body p-micro">
        <CalendarDaysIcon className="h-xxs w-xxs text-ctx-content-placeholder" />
      </span>
      <p className="text-center ts-heading-xs text-ctx-content-title">
        {t('consolidation.initial.title')}
      </p>
      <p className="max-w-[34rem] text-center ts-paragraph-xs text-ctx-content-placeholder">
        {t('consolidation.initial.description')}
      </p>
    </div>
  );
}
